<template>

    <div class="page-wrapper">

       <!-- Menu Superior de Navegación -->
       <navbar-new></navbar-new>
       
       <!-- Header Star + Foto -->
       <header-about></header-about>

       <!-- Mini acerca de nosotros TEXT =>Acerca de Nosotros -->
      <about-start></about-start>

      <!-- texto En -> IEH ofrecemos una gran diversidad de servicios eléctricos: -->
      <we-offert></we-offert>
      <!-- Misión, Visión Y Valores -->
      <faq-about></faq-about>

      <brand-start></brand-start>

       <!-- Pie de Página -->
       <footer-new></footer-new>
        

    </div>
</template>
  
<script>
  import navbarNew from '../components/navbar.vue'

  import headerAbout from '../components/about/headerAbout.vue'

  import aboutStart from '../components/about/aboutStart.vue'

  import weOffert from '../components/about/weOffert.vue'

  import faqAbout from '../components/about/faqAbout.vue'

  import brandStart from '../components/about/brandStart.vue'

  import footerNew from '../components/footer.vue'

  export default {
    components: {
    navbarNew,
    headerAbout,
    aboutStart,
    weOffert,
    faqAbout,
    brandStart,
    footerNew
  }
  }
  
</script>
  